import { useState, useEffect, useRef } from 'react';
import { View, Text, TextInput, FlatList } from 'react-native';
import { appColors } from '../global/constant/colors';
import CustomTillProductCard from './CustomTillProductCard';
import { Svg, Path } from 'react-native-svg';
import useCategory from '../hooks/useCategory';
import useProduct from '../hooks/useProduct';
import useOrg from '../hooks/useOrg';
import CustomButton from './CustomButton';

interface IProps {
  removeFocus: () => void;
  setKeyDown: (val: any) => void;
  setSearchQuery: (val: any) => void;
  inputRef: any;
  searchQuery: any;
}

const ProductContainer = ({ inputRef, removeFocus, setKeyDown, setSearchQuery, searchQuery }: IProps) => {
  const { getAllCategoryOnLocalDB, searchCategoryWithKeyWordOnLocalDB, showProduct, setShowProduct } = useCategory();
  const { getAllProductOnLocalDB, getAllProductOnLocalDBByKeySearch, allShopProductData, getAllProductQuickItem } =
    useProduct();
  const { getOrgData, org } = useOrg();

  useEffect(() => {
    getAllCategoryOnLocalDB();
    getAllProductOnLocalDB();
    getOrgData();
  }, []);

  useEffect(() => {
    getAllProductOnLocalDBByKeySearch(searchQuery);
    console.log('searchQuery', searchQuery);
    getOrgData();
  }, [searchQuery]);

  const handleKeyDown = (e: any) => {
    // List of keycodes or check for barcode pattern
    console.log('key down', e);
    if (e.keyCode >= 48 && e.keyCode <= 57) {
      // Prevent numeric input
      e.preventDefault();
      inputRef.current?.blur();
      setKeyDown(e);
    }
  };
  const [isQuickItem, setIsQuickItem] = useState(false);
  const onGetAllProductQuickItem = () => {
    setIsQuickItem(!isQuickItem);
  };

  useEffect(() => {
    if (isQuickItem) {
      getAllProductQuickItem();
    } else {
      getAllProductOnLocalDBByKeySearch('');

    }
  }, [isQuickItem]);

  return (
    <>
      <View style={{ flexDirection: 'row', width: '100%' }}>
        <View style={{ flexDirection: 'row' }}>
          <Text style={{ fontWeight: '700', color: 'rgba(30, 30, 30, 1)', marginLeft: 10 }}>PRODUCTS</Text>
        </View>

        <div style={{ marginTop: -20, width: '100%', marginLeft: 0, justifyContent: 'flex-end', display: 'flex' }}>
          <div style={{ marginRight: '5px' }}>
            <CustomButton
              padding={3}
              width={'100%'}
              bntType="primary"
              mode="contained"
              text={isQuickItem ? 'All Items' : 'Quick Items'}
              onPress={() => onGetAllProductQuickItem()}
            />
          </div>
          <TextInput
            ref={inputRef}
            textAlign="center"
            textAlignVertical="center"
            keyboardAppearance="default"
            placeholder="Search"
            onKeyPress={handleKeyDown}
            onPointerLeave={() => removeFocus()}
            style={{
              height: 50,
              padding: 13,
              backgroundColor: appColors.secondary,
              borderColor: 'rgba(30, 30, 30, 0.5)',
              borderWidth: 1,
              borderRadius: 10,
            }}
            value={searchQuery}
            onChangeText={setSearchQuery}
          />
        </div>
      </View>

      <FlatList
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          marginTop: 40,
        }}
        ListHeaderComponent={
          <>
            {allShopProductData.length < 1 && (
              <>
                <Text style={{ fontSize: 15, fontWeight: '900', textAlign: 'center' }}>No Product Created Yet</Text>
              </>
            )}
          </>
        }
        numColumns={3}
        keyExtractor={(item, index: any) => index}
        renderItem={({ item }) => <CustomTillProductCard setSearchQuery={setSearchQuery} data={item} />}
        data={allShopProductData}
      />
    </>
  );
};

export default ProductContainer;
